import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { CancelRefundRequestInput } from '../domain/dtos/cancel-refund-request-input'
import { Refund } from '../domain/dtos/refund'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class CancelRefundRequest {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: CancelRefundRequestInput): Promise<Refund> {
    const response = await this.httpClient.request({
      method: HttpMethod.PATCH,
      url: `${Envs.BFF_WEB_URL}/refunds/${input.refundId}/cancel`,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }
}
